import { Box, Link, List, ListItem, Typography } from "@mui/material";
import React from "react";
import { openTemplateImage } from "../api/createTemplate";
import { formatTaskSchedule } from "../utils/taskSchedule";
import { convertTextWithLinks } from "../utils/textUtils";

export function sortTasks(data) {
  if (!data) return data;

  const groups = data.task_groups || data.template_task_groups;
  if (!groups) return data;

  groups.sort((a, b) => a.order - b.order);
  groups.forEach((group) => {
    const tasks = group.tasks || group.template_tasks;
    if (tasks) {
      tasks.sort((a, b) => a.order - b.order);
    }
  });

  return data;
}

async function handleImageOpen(imagePath) {
  try {
    await openTemplateImage(imagePath);
  } catch (error) {
    console.error("画像表示エラー:", error);
    window.alert("画像の表示に失敗しました。");
  }
}

export function TaskBody({
  name,
  detail,
  images,
  compact = false,
  recurrenceType,
  weeklyDays = [],
  monthlyDays = [],
}) {
  const scheduleLabel = formatTaskSchedule(recurrenceType, weeklyDays, monthlyDays);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        minHeight: compact ? "auto" : "48px",
        ...(compact && { flexGrow: 1, mr: 1, overflow: "hidden" }),
      }}
    >
      <Typography
        variant={compact ? "subtitle2" : "subtitle1"}
        sx={{
          wordBreak: "break-word",
          fontWeight: 700,
          fontSize: compact ? "1rem" : undefined,
          lineHeight: compact ? 1.2 : 1.35,
          ...(compact && {
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }),
        }}
        title={name}
      >
        {name}
      </Typography>
      {scheduleLabel && (
        <Typography
          variant="caption"
          color="primary.main"
          sx={{ mt: compact ? 0.125 : 0.5, fontWeight: 600 }}
        >
          {scheduleLabel}
        </Typography>
      )}
      {detail && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            whiteSpace: "pre-wrap",
            mt: compact ? 0.25 : 0.75,
            lineHeight: compact ? 1.4 : 1.6,
          }}
        >
          {convertTextWithLinks(detail)}
        </Typography>
      )}
      {images && images.length > 0 && (
        <Box sx={{ mt: detail ? (compact ? 0.25 : 1.25) : compact ? 0.25 : 0.75 }}>
          <List
            dense
            disablePadding
            sx={{ pl: compact ? 0.5 : 1, display: "grid", gap: 0.5 }}
          >
            {images.map((img, index) => (
              <ListItem
                key={img.id || `img-${index}`}
                disableGutters
                sx={{ p: 0 }}
              >
                <Link
                  component="button"
                  type="button"
                  onClick={() => handleImageOpen(img.path)}
                  variant="body2"
                  sx={{
                    textDecoration: "underline",
                    cursor: "pointer",
                    color: "primary.main",
                    ...(compact && {
                      display: "block",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }),
                  }}
                  {...(compact && { title: img.display_name })}
                >
                  {img.display_name || "画像ファイル"}
                </Link>
              </ListItem>
            ))}
          </List>
        </Box>
      )}
    </Box>
  );
}
